import type { ReactNode } from "react";

import { cn } from "../../../lib/utils";

export const NavTab = ({
  title,
  onSelect,
  active,
  className,
}: {
  title: string | ReactNode;
  onSelect: () => void;
  active: boolean;
  className?: string;
}) => {
  return (
    <button
      type="button"
      onClick={onSelect}
      className={cn(
        "whitespace-nowrap rounded-md px-4 py-1.5 text-left capitalize transition-all hover:cursor-pointer hover:bg-[hsla(0,0%,100%,.06)]",
        active ? "font-bold" : "opacity-80",
        className,
      )}
    >
      {title}
    </button>
  );
};
